import React from 'react';
import _get from 'lodash/get';
import {
  components as DefaultSelectComponents,
  SingleValueProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import SsoPresetChip from '@lib/components/SsoPresetChip/SsoPresetChip';
import styles from '../Select.module.scss';

function SsoPresetSingleValue({
  children,
  ...restProps
}: SingleValueProps): React.ReactElement {
  const { options } = restProps;
  const selectValue = _get(restProps, 'selectProps.value');
  const value = _get(selectValue, 'value', '');
  const selectedOption = options.find(
    (option) => (option as SelectOption).value === value,
  ) as SelectOption | undefined;
  const { data } = selectedOption || {};
  const icon = _get(data, 'icon') as string | undefined;
  return (
    // @ts-ignore
    <DefaultSelectComponents.SingleValue
      {...restProps}
      className={styles.singleValue}
    >
      <div className={styles.singleValueBox}>
        <SsoPresetChip icon={icon} label={children} />
      </div>
    </DefaultSelectComponents.SingleValue>
  );
}

export default SsoPresetSingleValue;
